import { render, staticRenderFns } from "./WechatManagement.vue?vue&type=template&id=8d258e58&scoped=true"
import script from "./WechatManagement.vue?vue&type=script&lang=js"
export * from "./WechatManagement.vue?vue&type=script&lang=js"
import style0 from "./WechatManagement.vue?vue&type=style&index=0&id=8d258e58&prod&lang=less&scoped=true"
import style1 from "./WechatManagement.vue?vue&type=style&index=1&id=8d258e58&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d258e58",
  null
  
)

export default component.exports